import { Route, Routes } from "react-router-dom";
import { ProfilePage } from "../pages/facturacion/profile/ProfilePage";
import { InvoiceListPage } from "../pages/facturacion/dashboard/InvoiceListPage";
import { RequestInvoicePage } from "../pages/facturacion/invoices/RequestInvoicePage";
import { InvoiceDetailPage } from "../pages/facturacion/invoices/InvoiceDetailPage";
import { GuidePage } from "../pages/facturacion/GuidePage";

export const FacturacionRouter = () => {
  return (
    <Routes>
      <Route path="perfil" element={<ProfilePage />} />
      <Route path="" element={<InvoiceListPage />} />
      <Route path="nueva" element={<RequestInvoicePage />} />
      <Route path="facturas/:id" element={<InvoiceDetailPage />} />
      <Route path="guia" element={<GuidePage />} />
    </Routes>
  );
};
